import { createStyles, makeStyles, Theme  } from "@material-ui/core/styles";

const Styles = makeStyles((theme: Theme) => createStyles({
    root: {
        height: '100vh',
      },

      image: {
        // backgroundImage: 'url(https://source.unsplash.com/random)',
        backgroundImage: 'url(https://images.unsplash.com/photo-1599568882535-98668d85dea9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1158&q=80)',
        backgroundRepeat: 'no-repeat',
        backgroundColor:
          theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      },

      paper: {
        margin: theme.spacing(8, 4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '& .myForm>div': {
          margin: '30px 10px 15px !important'
        }
      },

      avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
      },

      form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
      },

      submit: {
        margin: theme.spacing(1, 0, 2),
      },

      or: {
        lineHeight: '1',
        position: 'relative',
        padding: '10px 0',
        display: 'block',
        width: '100%',
        "&:before": {
            content: '" "',
            position: 'absolute',
            height: '1px',
            backgroundColor: '#e4e8ee',
            top: '50%',
            left: '0',
            right: '0',
        },
      },
      orSpan: {
        position: 'relative',
        backgroundColor: '#fff',
        padding: '0 12.5px',
      },

      google: {
          margin: theme.spacing(1, 0, 2),
          backgroundImage: "linear-gradient(90deg, #4285f4, #34a853, #fbbc05, #ea4335)"
      },

      alertSpan: {
          color: "#3f51b5",
          padding: "3px 1px",
      }
}))

export default Styles;